import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Help from '../../Help/Help'
import { fieldUidRegex, getContentTypeFieldDataTestId, CONTENT_TYPE_FIELD_ACTION_IDS, NonLocalizableDom, handleToggleClick } from '../helper'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { booleanTestIdFormatter } from './../../../utils/helpers'
import GroupFieldTitleToggle from "../HelperComponents/GroupFieldTitleToggle"
import CustomUserLimit from './CustomUserLimit'
import ModularBlockInstanceTitleToggle from "../HelperComponents/ModularBlockInstanceTitleToggle"
import GlobalFieldTitleToggle from "../HelperComponents/GlobalFieldTitleToggle"

export const onLinkOptionsChangeMultipleHelper = (schema: any, checked: boolean) => {
  schema.multiple = checked;

  if (!checked) {
    if (schema.hasOwnProperty('min_instance')) {
      delete schema.min_instance;
    }
    if (schema.hasOwnProperty('max_instance')) {
      delete schema.max_instance;
    }

    if (schema.error && schema.error_details) {
      if (schema.error_details.hasOwnProperty('min_instance')) {
        delete schema.error_details.min_instance;
      }
      if (schema.error_details.hasOwnProperty('max_instance')) {
        delete schema.error_details.max_instance;
      }
    }
  } else {
    schema.error_details = {
      ...schema.error_details,
      max_instance: '',
      min_instance: ''
    };
  }

  schema.error =
    schema.error_details &&
    Object.keys(schema.error_details).filter((key) => schema.error_details[key]?.length).length
      ? true
      : false;
};

export const Link = (props: any) => {
  const { onChange, options, parentInfo, uniqueKey, schema, type, isNonLocalizable, hasNonLocalizablePlan, userCustomFieldLimits = { hasUserCustomFieldLimit: false, hasUserCustomFieldLimitRestFields: false }, hasNonLocalizablePlanForBlocksAndGroupMultiple, contentTypeSchemaTree, isGlobalFieldBuilderPage } = props
  const { hasUserCustomFieldLimit, hasUserCustomFieldLimitRestFields } = userCustomFieldLimits
  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef.current.focus()
  }, [displayNameRef])

  const onchange = () => {
    onChange && onChange(schema)
    setSchema({ ...schema })
  }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    if (schema.hasOwnProperty('display_name') && schema.newfield) {
      schema.uid = schema.display_name
        .trim()
        .replace(/[^A-Z0-9]+/gi, '_')
        .toLowerCase()
      if (schema.display_name) {
        schema.error_details = {
          ...schema.error_details,
          uid: ''
        }
      }
    }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onOptionsChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.mandatory`) {
      schema.mandatory = event.target.checked
    }
    if (event.target.name === `${uniqueKey}.multiple`) {
      if (event.target.checked) field_metadata.isTitle = false;
      onLinkOptionsChangeMultipleHelper(schema, event.target.checked);
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
      if (!schema.multiple) {
        delete schema.max_instance
      }
    }
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }
  const onDefaultValueTitleChange = (event: any) => {
    field_metadata.default_value.title = event.target.value
    onchange()
  }
  const onDefaultValueUrlChange = (event: any) => {
    field_metadata.default_value.url = event.target.value
    onchange()
  }
  const onMaxInstance = (event: any) => {
    schema.max_instance = event.target.value ? parseInt(event.target.value) : null

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (event.target.value.length && schema.max_instance < 0) {
      schema.error_details = {
        ...schema.error_details,
        max_instance: 'max instance cannot be less then zero'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        max_instance: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }

    onchange()
  }

  if (type === 'basic') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}-label`} className='FieldLabel__CT' version='v2' required htmlFor="displayName">
            Display Name
          </FieldLabel>
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.displayName`}
            value={display_name}
            onChange={onDisplayNameChange}
            inputRef={displayNameRef}
            error={schema.error && schema.error_details.display_name ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.DISPLAY_NAME_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-label`} className='FieldLabel__CT' version='v2' required htmlFor="uid">
            Unique ID
          </FieldLabel>
          <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}-help-text`} text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.uid`}
            value={uid}
            onChange={onUidChange}
            error={(schema.error && schema.error_details.uid) || error ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.UID_INPUT)}
          />
        </Field>

        <Field>
          <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-label`} className='FieldLabel__CT' version='v2' htmlFor="instruction">Instruction Value</FieldLabel>
          <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}-help-text`} text="Helps you add instructions for this field. The instructional text will appear below the field." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.instruction`}
            value={field_metadata.instruction || ''}
            onChange={onInstructionChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            // multiline={true}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.INSTRUCTION_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-label`} className='FieldLabel__CT' version='v2' htmlFor="helpText">Help Text</FieldLabel>
          <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}-help-text`} text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.helpText`}
            value={field_metadata.description || ''}
            onChange={onHelpTextChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            // multiline={true}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
            id={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.HELP_TEXT_INPUT)}
          />
        </Field>
      </div>
    )
  } else if (type === 'advanced') {
    return (
      <div className="FormFields">
        <div className='FormFields__sub_block-label' >
          <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.TITLE_INPUT)}-label`} version='v2' htmlFor="defaultValue">Default Value</FieldLabel>
          <Help type="basic" testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.TITLE_INPUT)}-help-text`} text="Set a default field value for this field. The value will appear by default while creating an entry for this content type." />
        </div>
        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' htmlFor="validation">Title:</FieldLabel>
          <TextInput
            version='v2'
            name={`${uniqueKey}.defaultValue.title`}
            value={field_metadata.default_value.title || ''}
            onChange={onDefaultValueTitleChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.TITLE_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.URL_INPUT)}-label`} className='FieldLabel__CT' version='v2' htmlFor="validation">URL:</FieldLabel>
          <TextInput
            version='v2'
            name={`${uniqueKey}.defaultValue.url`}
            value={field_metadata.default_value.url || ''}
            onChange={onDefaultValueUrlChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.URL_INPUT)}
          />
        </Field>
        <Field>
          <FieldLabel testId='cs-content-field-link-advanced-options' className='FieldLabel__CT' version='v2' htmlFor="options">Other Options</FieldLabel>

          <div className='ToggleWrap'>
            <ToggleSwitch
              testId={booleanTestIdFormatter("cs-ct-field-link-mandatory", schema.mandatory)}
              name={`${uniqueKey}.mandatory`}
              label="Mandatory"
              checked={schema.mandatory}
              onClick={onOptionsChange}
            />
          </div>
          <div className='ToggleWrap'>
            <ToggleSwitch
              testId={booleanTestIdFormatter("cs-ct-field-link-multiple", schema.multiple)}
              name={`${uniqueKey}.multiple`}
              label="Multiple"
              checked={schema.multiple}
              onClick={onOptionsChange}
            />
          </div>
          {schema.multiple ?
           hasUserCustomFieldLimitRestFields ? (
            <CustomUserLimit
              uniqueKey={uniqueKey}
              schema={schema}
              onchange={onchange}
              t={props.t}
              type={type}
            />
          ) : (
            <div className='ToggleWrap__sub_Field' >
              <Field>
                <FieldLabel testId={`${getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}-label`} className='FieldLabel__CT' version='v2' htmlFor="validation">
                  Set Maximum Limit
                </FieldLabel>
                <TextInput
                  version='v2'
                  type="number"
                  name={`${uniqueKey}.maxinstance`}
                  value={schema.max_instance || null}
                  onChange={onMaxInstance}
                  // placeholder="Maximum"
                  placeholder={props.t(
                    'content_type.save_content_type.body.fields.common_properties.placeholders.maximum'
                  )}
                  error={schema.error && schema.max_instance ? true : false}
                  testId={getContentTypeFieldDataTestId(schema, type, CONTENT_TYPE_FIELD_ACTION_IDS.SET_MAX_LIMIT_INPUT)}
                />
              </Field>
            </div>
          ) : null}
          {
            hasNonLocalizablePlan ? (
              hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                <NonLocalizableDom
                  isFieldPresent={true}
                  uniqueKey={uniqueKey}
                  schema={schema}
                  onOptionsChange={onOptionsChange}
                  dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-ct-field-link-non-localizable-parent-multiple` : `cs-ct-field-link-non-localizable`, schema.non_localizable)}
                  dataTestIdForDescription={"cs-ct-field-link-non-localizable-description"}
                  isNonLocalizable={isNonLocalizable}
                  isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                  userCustomFieldLimits={{ hasUserCustomFieldLimit, hasUserCustomFieldLimitRestFields}}
                />
              ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                <NonLocalizableDom
                  isFieldPresent={true}
                  uniqueKey={uniqueKey}
                  schema={schema}
                  onOptionsChange={onOptionsChange}
                  dataTestId={booleanTestIdFormatter("cs-ct-field-link-non-localizable", schema.non_localizable)}
                  dataTestIdForDescription={"cs-ct-field-link-non-localizable-description"}
                  isNonLocalizable={isNonLocalizable}
                  isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                  userCustomFieldLimits={{ hasUserCustomFieldLimit, hasUserCustomFieldLimitRestFields}}
                />
                : null
            ) : null
          }

        </Field>
        <GroupFieldTitleToggle
          parentInfo={parentInfo}
          uniqueKey={uniqueKey}
          field_metadata={field_metadata}
          onchange={onchange}
          multiple={schema?.multiple}
          testId="cs-ct-field-link-group-title"
        />
         <GlobalFieldTitleToggle
          parentInfo={parentInfo}
          uniqueKey={uniqueKey}
          field_metadata={field_metadata}
          onchange={onchange}
          multiple={schema?.multiple}
          testId="cs-ct-field-link-global-title"
          schema={schema}
          contentTypeSchemaTree={contentTypeSchemaTree}
          isGlobalFieldBuilderPage={isGlobalFieldBuilderPage}
        />
        <ModularBlockInstanceTitleToggle
          parentInfo={parentInfo}
          uniqueKey={uniqueKey}
          field_metadata={field_metadata}
          onchange={onchange}
          multiple={schema?.multiple}
          testId="cs-ct-field-link-modular-block-instance-title"
          schema={schema}
        />
      </div>
    )
  }
}

export default React.memo(Link)
